import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const ProfilePicture = ({ auth: { user }, setprofilePicOpen, profile }) => {
  return (
    <Fragment>
      <div id="overlay-root" onClick={(e) => setprofilePicOpen(false)}>
        <div className="profile-picture-overlay">
          <div className="profile-avi-container">
            <i
              className="fas fa-times fa-3x profile-x"
              onClick={(e) => setprofilePicOpen(false)}
            ></i>
            <div className="profile-picture-circle green">
              <img
                className="profile-picture"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  profile && profile.avatar
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ProfilePicture.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ProfilePicture);
